export class ObjectUtils {

    private static UTILS_EXTRACT_ARRAY_LOCATOR_CONDITION_REGEX = '\\[(.+)\\]';
    private static UTILS_EXTRACT_ARRAY_KEY_REGEX = '(.+)\\[';


    public static pathValid(obj: any, path: string, useEmptyVal: boolean = false, usePartialPath: boolean = false): boolean {
        if (path.length === 0) {
            return true;
        }
        const extractedVal = ObjectUtils.walk(obj, path, useEmptyVal, usePartialPath);
        return extractedVal !== null;
    }

    public static walk(obj: any, path: string, useEmptyVal: boolean = false, usePartialPath: boolean = false): any {
        const splitPath = path.split('.');

        //parameterNameLooksLikeArray handles the case when a field name seems as an array name. For example, in 'ADMIN-PRACTITIONER-EDITING-DEFAULT' there is a field
        //named 'telecom[2].value' which in 'obj' parameter here appears as the following parameter name: obj['telecom[2].value'] and not as an array (like obj.telecom[2].value.
        const parameterNameLooksLikeArray = splitPath.length > 1 && obj.hasOwnProperty(path);
        let _objPoint = obj;

        for (const i in splitPath) {
            if (splitPath.hasOwnProperty(i)) {
                const p = splitPath[i];
                if (parameterNameLooksLikeArray || p.indexOf('[') === -1) {
                    if (!useEmptyVal && _objPoint[p]) {
                        _objPoint = _objPoint[p];
                    } else if (useEmptyVal && _objPoint && _objPoint[p] !== undefined && _objPoint[p] !== null) {
                        _objPoint = _objPoint[p];
                    } else if (!usePartialPath) {
                        return null;
                    }
                    continue;
                }

                const _extractCondRegEx = new RegExp(ObjectUtils.UTILS_EXTRACT_ARRAY_LOCATOR_CONDITION_REGEX);
                const _extractedCondition = _extractCondRegEx.exec(p);
                const _extractArrayName = new RegExp(ObjectUtils.UTILS_EXTRACT_ARRAY_KEY_REGEX);
                const _arrayKeyName = _extractArrayName.exec(p);
                if (!Number.isNaN(Number.parseInt(_extractedCondition[1]))) {
                  if (_objPoint[_extractedCondition[1]]) {
                    _objPoint = _objPoint[_extractedCondition[1]];
                  } else {
                    _objPoint = _objPoint[_arrayKeyName[1]][_extractedCondition[1]];
                  }
                } else {
                    const filteredObj = (<Array<any>> _objPoint[_arrayKeyName[1]])
                        .filter(v => ObjectUtils.checkConditionOnObject(v, _extractedCondition[1]));

                    if (filteredObj.length === 0) {
                        _objPoint = null;
                    } else {
                        _objPoint = filteredObj[0];
                    }
                }
            }
        }
        return _objPoint;

    }


    private static checkConditionOnObject(obj, condition): boolean {
        const splitCondition = condition.split(' ');
        const key = splitCondition[0];
        const cond = splitCondition[1];
        const val = splitCondition[2];

        switch (cond) {
            case '==':
                return obj[key] === val;
            case '>=':
                return Number.parseInt(obj[key]) >= Number.parseInt(val);
            case '<=':
                return Number.parseInt(obj[key]) <= Number.parseInt(val);
            case '!=':
                return obj[key] !== val;
            default:
                return false;
        }



    }
}
